import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

export const Container = styled.div`
  padding: 11px 0;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const UserName = styled.span`
  font-size: 12.6px;
  padding: 0 16px;
  letter-spacing: 0.02em;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12.6px;
  color: ${theme.colors.primary.black};
`;

export const AlertContainer = styled.div`
  margin-left: 40px;
  svg {
    display: flex;
  }
`;
